/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBack = createReactComponent("arrow-back", "IconArrowBack", [
  ["path", { d: "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1", key: "svg-0" }]
]);

export { IconArrowBack as default };
//# sourceMappingURL=IconArrowBack.js.map
